import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    bookingData: Object
  }

  static targets = [
    "firstName",
    "lastName", 
    "email",
    "phoneNumber",
    "startDivingDate",
    "hotelName",
    "roomNumber"
  ]

  connect() {
    console.log("Autofill controller connected", this.bookingDataValue)
  }

  fill(event) {
    event.preventDefault()
    
    const booking = this.bookingDataValue
    
    if (!booking) {
      console.error("No booking data available")
      return
    }

    // Parse full name into first and last name
    if (booking.full_name && this.hasFirstNameTarget && this.hasLastNameTarget) {
      const nameParts = booking.full_name.trim().split(/\s+/)
      
      if (nameParts.length === 1) {
        this.firstNameTarget.value = nameParts[0]
        this.lastNameTarget.value = ""
      } else {
        this.firstNameTarget.value = nameParts[0]
        this.lastNameTarget.value = nameParts.slice(1).join(" ")
      }
      
      this.highlightField(this.firstNameTarget)
      this.highlightField(this.lastNameTarget)
    }

    // Fill email
    if (booking.email && this.hasEmailTarget) {
      this.emailTarget.value = booking.email
      this.highlightField(this.emailTarget)
    }

    // Fill phone number
    if (booking.phone && this.hasPhoneNumberTarget) {
      this.phoneNumberTarget.value = booking.phone
      this.highlightField(this.phoneNumberTarget)
    }

    // Fill start diving date from preferred_date
    if (booking.preferred_date && this.hasStartDivingDateTarget) {
      this.startDivingDateTarget.value = booking.preferred_date
      this.highlightField(this.startDivingDateTarget)
    }

    // Fill hotel name if accommodation was requested
    if (booking.requires_accommodation && this.hasHotelNameTarget) {
      this.hotelNameTarget.value = "Arena Beach Hotel"
      this.highlightField(this.hotelNameTarget)
    }

    // Fill room number/type if available
    if (booking.room_type && this.hasRoomNumberTarget) {
      this.roomNumberTarget.value = booking.room_type
      this.highlightField(this.roomNumberTarget)
    }

    // Show success message
    this.showSuccessMessage()
  }

  highlightField(field) {
    field.classList.add('autofilled')
    
    // Remove highlight after 2 seconds
    setTimeout(() => {
      field.classList.remove('autofilled')
    }, 2000)
  }

  showSuccessMessage() {
    // Create a temporary success message
    const message = document.createElement('div')
    message.className = 'alert alert-success alert-dismissible fade show'
    message.innerHTML = `
      <i class="bi bi-check-circle me-2"></i>
      <strong>Auto-filled!</strong> Information from your booking has been populated.
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `
    
    // Insert at the top of the form
    const form = this.element.closest('form')
    if (form) {
      form.insertBefore(message, form.firstChild)
      
      // Auto-dismiss after 5 seconds
      setTimeout(() => {
        message.remove()
      }, 5000)
    }
  }
}
